import { FC } from 'react'
import { OwnerSummary } from 'src/v2/views/owner-reveal/sidebar/owner-summary'
import { HeaderCover } from 'src/v2/components/sidebar-header-cover'
import { SidebarHeaderContent } from 'src/v2/components/sidebar-header-content'
import { SidebarHeader } from 'src/v2/components/sidebar-header'
import { PropertyDistributionItem } from 'src/v2/views/owner-reveal/sidebar/result-overlay/properties-distribution-list'

type HeaderCoverProps = {
  image?: string
  icon: React.ReactNode
  iconBackground?: string
  iconBorderColor?: string
  onClickSave?: () => void
  saved?: boolean
  backText?: string
  onBackClick?: () => void
  onClose?: () => void
}

type HeaderContentProps = {
  title?: string
  subtitle?: string
  type?: string
  amountOfContacts: number
  amountOfParcels: number
  distributions: Record<string, number>
  propertiesDistributions?: PropertyDistributionItem[]
  badge?: string
}

type SidebarEntityHeaderProps = HeaderCoverProps & HeaderContentProps

export const SidebarEntityHeader: FC<SidebarEntityHeaderProps> = ({
  image,
  icon,
  iconBackground,
  iconBorderColor,
  title,
  subtitle = '—',
  type,
  onClickSave,
  saved,
  amountOfContacts,
  amountOfParcels,
  distributions,
  propertiesDistributions,
  backText,
  onBackClick,
  onClose,
  badge,
}) => {
  return (
    <SidebarHeader
      cover={
        <HeaderCover
          icon={icon}
          iconBackground={iconBackground}
          iconBorderColor={iconBorderColor}
          image={image}
          onClickSave={onClickSave}
          saved={saved}
          backText={backText}
          onBackClick={onBackClick}
          onClose={onClose}
          badge={badge}
        />
      }
      content={
        <SidebarHeaderContent subtitle={subtitle} title={title} type={type}>
          <OwnerSummary
            amountOfContacts={amountOfContacts}
            amountOfParcels={amountOfParcels}
            distributions={distributions}
            propertiesDistributions={propertiesDistributions}
          />
        </SidebarHeaderContent>
      }
    />
  )
}
